<template>
    <div>
        <div calss="">
            <HomeDecorVue v-if="view == 'home' && $store.getters.get_company.id == 4" />
            <HomeAqVue v-if="view == 'home' && $store.getters.get_company.id != 4" />
            <!-- <AsistenciaVue @setView="setView" v-if="view == 'asistencia'" /> -->
            <MaintenanceVue @setView="setView" v-if="view == 'mantenimiento'" />

            <CloseBeadVue @setView="setView" v-if="view == 'close_bead' && $store.getters.get_company.id == 1" />
            <CloseBeadAqVue @setView="setView" v-if="view == 'close_bead' && $store.getters.get_company.id == 3" />
            <CloseBeadVue @setView="setView" v-if="view == 'close_bead' && $store.getters.get_company.id == 4" />

            <ProccessVue v-if="view == 'proccess'" @mtdViewFooter="mtdViewFooter" @setView="setView" />

            <ReportView v-if="view == 'reports' && $store.getters.get_company.id == 1" @mtdViewFooter="mtdViewFooter" @setView="setView" />
            <ReportView v-if="view == 'reports' && $store.getters.get_company.id == 3" @mtdViewFooter="mtdViewFooter" @setView="setView" />
            <ReportView v-if="view == 'reports' && $store.getters.get_company.id == 4" @mtdViewFooter="mtdViewFooter" @setView="setView" />
        </div>
        <FooterDecorVue v-if="view == 'home' && $store.getters.get_company.id == 4" :view="view" @setView="setView" />
        <FooterAqVue v-if="view == 'home' && $store.getters.get_company.id != 4" :view="view" @setView="setView" />
    </div>
</template>

<script>
import FooterAqVue from "../../components/Supervisor/aq/Footer.vue";
import HomeAqVue from "../../components/Supervisor/aq/Home.vue";
import FooterDecorVue from "../../components/Supervisor/decor/Footer.vue";
import HomeDecorVue from "../../components/Supervisor/decor/Home.vue";
import ProccessVue from '../proccess/ProccessView.vue';
import CloseBeadVue from "../../components/caja/demo/page/CloseBead.vue";
import CloseBeadAqVue from "../../components/caja/aq/page/CloseBead.vue";
import MaintenanceVue from "../../views/maintenance/index.vue";
import ReportView from '../reports/ReportsView.vue';
// import AsistenciaVue from "../../components/asistencia/Asistencia.vue";


export default {
    components: { FooterAqVue, HomeAqVue, FooterDecorVue, HomeDecorVue, MaintenanceVue, ProccessVue, CloseBeadVue,CloseBeadAqVue, ReportView},
    data() {
        return {
            view: "home",
        };
    },
    methods: {
        setView: function (payload) {
            this.view = payload;
        },
        mtdViewFooter: function (boo, view) {
            this.booFooter = boo;
            if (boo == true) this.view = view;
        }
    },
};
</script>

<style lang="scss" scoped></style>
